export interface Principal {
  Id: string; // The ObjectId in Azure AD
  PrincipalType: PrincipalType;
}

export enum PrincipalType {
  Group = 0,
  User = 1
}
